import { useWSModal, WSCard, WSList } from "@wingspanhq/fe-component-library";
import {
  VaultFileKind,
  VaultFileVisibility
} from "@wingspanhq/wingspan-api-sdk";
import { useCallback } from "react";
import { queriesAccounts, queriesVaultFiles } from "@query";
import { useSession } from "@hooks/useSession";
import { DataViewGrid } from "../../../../../shared/components/DataView";
import { useMutationUploadVaultFile } from "../../../../../v3/utils/useMutationUploadVaultFile";
import { FormEditLink } from "../components/FormEditLink";

type Props = {};

export const RouteMarketing: React.FC<Props> = () => {
  const session = useSession();
  const queryAccount = queriesAccounts.getAccount.useQuery({
    accountId: session.accountId
  });

  const modalEditLinkedIn = useWSModal(FormEditLink, {
    size: "S",
    title: "LinkedIn"
  });

  const modalEditInstagram = useWSModal(FormEditLink, {
    size: "S",
    title: "Instagram URL"
  });

  const modalEditX = useWSModal(FormEditLink, {
    size: "S",
    title: "X URL"
  });

  const modalEditOtherWebsite = useWSModal(FormEditLink, {
    size: "S",
    title: "Other website"
  });

  const logoFileId = queryAccount.data?.profile?.logoFileId;

  const queryLogo = queriesVaultFiles.getVaultFile.useQuery(
    { fileId: logoFileId! },
    { enabled: !!logoFileId }
  );

  const [uploadVaultFile] = useMutationUploadVaultFile();
  const [updateAccount, updateAccountMeta] =
    queriesAccounts.updateAccount.useMutation({
      dependencies: [queriesAccounts.getAccount.queryKeyBase]
    });

  const handleLogoEdit = useCallback(() => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.click();

    fileInput.onchange = (event: any) => {
      event.stopPropagation();
      event.preventDefault();
      updateAccountMeta.reset();
      if (event.target && event.target.files && event.target.files) {
        const logoFile = event.target.files[0];
        uploadVaultFile(
          {
            file: logoFile,
            kind: VaultFileKind.GENERIC,
            visibility: VaultFileVisibility.PUBLIC
          },
          {
            onSuccess: vaultFile => {
              updateAccount({
                accountId: session.accountId,
                accountUpdate: { profile: { logoFileId: vaultFile.id } }
              });
            }
          }
        );
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!queryAccount.data) {
    return null;
  }

  const links = queryAccount.data?.profile?.company?.links;

  return (
    <WSCard header="Marketing" divider>
      <WSList gap="L">
        <DataViewGrid
          data={[
            {
              label: {
                text: "Logo",
                actionPosition: "left",
                action: {
                  label: logoFileId ? "Edit" : "Add",
                  onClick: handleLogoEdit
                }
              },
              value: queryLogo.data?.fileUrl,
              type: "image"
            }
          ]}
        />
        <DataViewGrid
          data={[
            {
              label: {
                text: "LinkedIn",
                actionPosition: "left",
                action: {
                  label: "Edit",
                  onClick: () => {
                    modalEditLinkedIn.open({
                      name: "linkedInUrl",
                      label: "LinkedIn"
                    });
                  }
                }
              },
              value: links?.linkedInUrl
            },
            {
              label: {
                text: "Instagram URL",
                actionPosition: "left",
                action: {
                  label: "Edit",
                  onClick: () => {
                    modalEditInstagram.open({
                      name: "instagramUrl",
                      label: "Instagram URL"
                    });
                  }
                }
              },
              value: links?.instagramUrl
            },
            {
              label: {
                text: "X URL",
                actionPosition: "left",
                action: {
                  label: "Edit",
                  onClick: () => {
                    modalEditX.open({
                      name: "twitterUrl",
                      label: "X URL"
                    });
                  }
                }
              },
              value: links?.twitterUrl
            },
            {
              label: {
                text: "Other website",
                actionPosition: "left",
                action: {
                  label: "Edit",
                  onClick: () => {
                    modalEditOtherWebsite.open({
                      name: "otherUrl",
                      label: "Other website"
                    });
                  }
                }
              },
              value: links?.otherUrl
            }
          ]}
        />
      </WSList>
    </WSCard>
  );
};
